// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__yZzlP","consentsList":"PatientConsents_consentsList__22dMQ","consentsListEmpty":"PatientConsents_consentsListEmpty__yazcA"};